module.exports = __webpack_public_path__ + "img/cover_photo.21accf0b.jpg";